module.exports = __webpack_public_path__ + "img/intersystems_application_partner_blue.63170d1d.png";